/** AsyncStorage key — last phase written *before* each risky native call. */
export const LAUNCH_DIAGNOSTICS_STORAGE_KEY = 'zporti_launch_diagnostics_last_phase';

/** Filter Console.app / Xcode device logs with this string. */
export const LAUNCH_DIAGNOSTICS_LOG_PREFIX = '[ZPORTI_LAUNCH]';

export const LAUNCH_PHASE = {
  JS_ENTRY: 'js_entry',
  PROVIDER_MOUNT: 'provider_mount',
  APP_LAYOUT_MOUNT: 'app_layout_mount',
  PREVIOUS_PHASE_REPORT: 'previous_phase_report',
  DEFERRED_SDK_READY: 'deferred_sdk_ready',
  SENTRY_INIT_START: 'sentry_init_start',
  SENTRY_INIT_OK: 'sentry_init_ok',
  SENTRY_INIT_SKIP: 'sentry_init_skip',
  POSTHOG_PROVIDER_MOUNT: 'posthog_provider_mount',
  MIXPANEL_INIT_START: 'mixpanel_init_start',
  MIXPANEL_INIT_OK: 'mixpanel_init_ok',
  MIXPANEL_INIT_SKIP: 'mixpanel_init_skip',
  REVENUECAT_CONFIGURE_START: 'revenuecat_configure_start',
  REVENUECAT_CONFIGURE_OK: 'revenuecat_configure_ok',
  REVENUECAT_CONFIGURE_SKIP: 'revenuecat_configure_skip',
  ANALYTICS_CONSENT_HYDRATE_START: 'analytics_consent_hydrate_start',
  ANALYTICS_CONSENT_HYDRATE_OK: 'analytics_consent_hydrate_ok',
} as const;

export type LaunchPhase = (typeof LAUNCH_PHASE)[keyof typeof LAUNCH_PHASE];
